import animateScroll from "./animateScroll";

const logError = function () {
    console.error(`Invalid element, is react ref correct?`)
}



const scrollTo = function ({ id, ref = null, duration = 3000 }) {


    const getElementPosition = function (element) {
        return element.offsetTop;
    }

    const initialPosition = window.scrollY;

    // decide what type of reference that is
    // if neither ref or id is provided  set element to null
    const element = ref ? ref.current : id ? document.getElementById(id) : null;

    if (!element) {
        logError();
        return;
    }



    animateScroll({
        targetPosition: getElementPosition(element),
        initialPosition,
        duration,
    })
};

export default scrollTo;